import { render, staticRenderFns } from "./OrderMobile.vue?vue&type=template&id=23c701e1&scoped=true&"
import script from "./OrderMobile.vue?vue&type=script&lang=js&"
export * from "./OrderMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrderMobile.vue?vue&type=style&index=0&id=23c701e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c701e1",
  null
  
)

export default component.exports